<template>

    <div class="container">
      <h1>Ølkort</h1>
      <div v-for="beer in beers" :key="beer.id">
          <router-link :to="{ name: 'øl', params: { beer: beer }}">
            <Beer
              :beer="beer"
            ></Beer>
          </router-link>
      </div>
    </div>

</template>

<script>

import Beer from '../components/Beer.vue';

export default {
  name: 'BeerList',
  components: {
    Beer
  },
  props: {
    beers: Array
  },
  data(){
    function buildThresholdList(num) {
       let thresholds = [];
       let numSteps = num;

       for (let i=1.0; i<=numSteps; i++) {
         let ratio = i/numSteps;
         thresholds.push(ratio);
       }

       thresholds.push(0);
       return thresholds;
     }
    return {
      observer: null,
      lazyImages: [],
      options: {
        root: null,
        rootMargin: '110px',
        threshold: buildThresholdList(50)
      }
    }

  },
  watch: {
    beers: function(){
      setTimeout(() => {
        this.lazyImages = this.$el.querySelectorAll('.beer img');

        this.lazyImages.forEach(img => {
          this.observer.observe(img);
        });
      });
    }
  },
  mounted(){
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          this.observer.unobserve(lazyImage);
        }
      });
    }, this.options);
    this.lazyImages = this.$el.querySelectorAll('.beer img');

    this.lazyImages.forEach(img => {
      this.observer.observe(img);
    });
  },
  destroyed() {
    this.observer.disconnect();
  },
}
</script>

<style scoped>
  a{
    color: inherit;
    text-decoration: inherit;
  }
</style>
